module.exports = __webpack_public_path__ + "img/step4t.ce0670eb.png";